import { createUseMutation } from 'api/common/createUseMutation'
import { postSignedUrl } from 'api/fetchers/postSignedUrl'

export const usePostSignedUrl = createUseMutation({
  fetcher: postSignedUrl,
})
